module.exports = __webpack_public_path__ + "static/jackie-938ff1f4fc3779b2f2400914c3b9ccc4.jpg";